module.exports = __webpack_public_path__ + "img/Maddie-McArthur.8cda24d6.jpg";